import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { Typography, Box } from '@material-ui/core';

import {
  useErrorStyles,
  useSuccessStyles,
  useWarningStyles,
  useInfoStyles,
} from './simplealertstyles';
import ErrorIcon from '../svg/ErrorIcon';
import Success from '../svg/Success';
import Warn from '../svg/Warn';
import InfoFilled from '../svg/InfoFilled';

const SimpleAlert = ({ variant, message, subText }) => {
  const errorClasses = useErrorStyles();
  const successClasses = useSuccessStyles();
  const warningClasses = useWarningStyles();
  const infoClasses = useInfoStyles();
  let classes;
  let Icon;

  if (variant === 'error') {
    classes = errorClasses;
    Icon = ErrorIcon;
  } else if (variant === 'success') {
    classes = successClasses;
    Icon = Success;
  } else if (variant === 'warning') {
    classes = warningClasses;
    Icon = Warn;
  } else if (variant === 'info') {
    classes = infoClasses;
    Icon = InfoFilled;
  } else {
    return null;
  }

  return (
    <Paper elevation={0} className={classes.container}>
      <Box>
        <Icon className={classes.icon} />
      </Box>
      <Box>
        <Box>
          <Typography variant="body2" className={classes.content}>
            {message}
          </Typography>
        </Box>
        {subText && (
          <Box>
            <Typography variant="body2" className={classes.subText}>
              {subText}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

SimpleAlert.propTypes = {
  variant: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  message: PropTypes.string.isRequired,
};

SimpleAlert.defaultProps = {
  variant: 'success',
};

export default SimpleAlert;
